const getCountryList = state => state?.jobRole?.countryList
const getCompanyList = state => state?.jobRole?.companyList
const getPrefCities = state => state?.jobRole?.perfCityList
const getRoleData = state => state?.jobRole?.roleData
const elasticSearchData = state => state?.jobRole?.elasticSearchDegreeData
const getSpecialisationListData = state => state?.jobRole?.specialisationList

const selectors = {
  getCountryList,
  getCompanyList,
  getRoleData,
  elasticSearchData,
  getSpecialisationListData,
  getPrefCities,
}

export default selectors
